// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 사용자 관리 화면 */

/* ── 전체 레이아웃 ── */
.um-layout {
  display: flex;
  gap: 14px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* ── 좌측 패널 ── */
.um-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

/* ── 우측 패널 ── */
.um-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  min-width: 0;
}

/* ── 패널 헤더 ── */
.um-panel-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f0f2f8;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  border-bottom: 1px solid #dde2ef;
  flex-shrink: 0;
  gap: 8px;
}

.um-count { font-size: 12px; color: #777; font-weight: 400; }

/* ── 검색 ── */
.um-search-wrap {
  padding: 7px 10px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}
.um-search {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  box-sizing: border-box;
}
.um-search:focus { outline: none; border-color: #4a90e2; }

/* ── 필터 탭 ── */
.um-filter-tabs {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
}
.um-filter-tab {
  flex: 1 1;
  padding: 5px 4px;
  font-size: 11px;
  font-weight: 500;
  color: #666;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}
.um-filter-tab:hover { background: #f5f6ff; color: #333; }
.um-filter-tab.active { color: #1a1a2e; border-bottom-color: #4a90e2; font-weight: 700; background: #f0f4ff; }
.um-tab-cnt {
  display: inline-block;
  background: #e8e8e8;
  color: #555;
  border-radius: 8px;
  padding: 0 5px;
  font-size: 10px;
  margin-left: 2px;
  font-weight: 600;
}
.um-filter-tab.active .um-tab-cnt { background: #4a90e2; color: #fff; }

/* ── 사용자 카드 목록 ── */
.um-user-list {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.um-user-card {
  padding: 9px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.1s;
}
.um-user-card:hover    { background: #f6f8ff; }
.um-user-card.selected { background: #eef2ff; border-left: 3px solid #4a90e2; padding-left: 9px; }
.um-user-card:last-child { border-bottom: none; }

.um-card-row1 {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.um-card-name { font-size: 13px; font-weight: 700; color: #222; }

.um-badge-admin    { font-size: 10px; background: #4a90e2; color: #fff; padding: 1px 5px; border-radius: 3px; font-weight: 500; }
.um-badge-tmp      { font-size: 10px; background: #e07000; color: #fff; padding: 1px 5px; border-radius: 3px; }
.um-badge-rejected { font-size: 10px; background: #c0392b; color: #fff; padding: 1px 5px; border-radius: 3px; }

.um-status-badge   { font-size: 10px; font-weight: 600; padding: 1px 7px; border-radius: 8px; margin-left: auto; flex-shrink: 0; }
.um-status--active   { background: #e6f9f0; color: #1a9052; }
.um-status--pending  { background: #fff4e0; color: #b35e00; }
.um-status--inactive { background: #f0f0f0; color: #999; }

.um-card-id    { font-size: 11px; color: #888; margin-top: 3px; }
.um-card-login { font-size: 11px; color: #999; margin-top: 2px; }
.um-card-agree {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  font-size: 11px;
  color: #555;
}

/* ── 액션 버튼 영역 ── */
.um-actions {
  border-top: 1px solid #dde2ef;
  padding: 9px 12px;
  flex-shrink: 0;
  background: #fafbff;
}
.um-actions-title { font-size: 11px; color: #666; font-weight: 600; margin-bottom: 6px; }
.um-actions-btns  { display: flex; flex-wrap: wrap; gap: 6px; }

.btn-outline {
  background: #fff;
  color: #333;
  border: 1px solid #bbb;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  padding: 3px 9px;
}
.btn-outline:hover:not(:disabled) { background: #f0f0f0; }
.btn-outline:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── 우측 빈 상태 ── */
.um-no-select {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  font-size: 14px;
}
.um-empty {
  padding: 16px;
  text-align: center;
  color: #aaa;
  font-size: 13px;
}

/* ── 권한 헤더 ── */
.um-perm-hd { flex-wrap: wrap; gap: 6px; }
.um-perm-hd-left { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; flex: 1 1; min-width: 0; }
.um-perm-title { font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.um-allchecks { display: flex; gap: 10px; flex-shrink: 0; }
.um-allcheck-lbl {
  display: flex; align-items: center; gap: 4px;
  font-size: 12px; font-weight: 500; color: #444;
  cursor: pointer; white-space: nowrap;
}
.um-allcheck-lbl input { width: 14px; height: 14px; cursor: pointer; accent-color: #4a90e2; }

/* ── 관리자 안내 ── */
.um-admin-notice {
  padding: 14px 16px;
  font-size: 13px;
  color: #4a90e2;
  background: #f0f6ff;
  border-bottom: 1px solid #d0e4ff;
}

/* ── 권한 테이블 영역 ── */
.um-perm-body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.um-perm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}
.um-perm-table th {
  padding: 6px 10px;
  background: #f4f6fa;
  border-bottom: 2px solid #dde2ef;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
  z-index: 1;
}
.um-th-group { width: 80px; }
.um-th-menuname { position: relative; -webkit-user-select: none; user-select: none; overflow: hidden; }
.um-col-resizer {
  position: absolute;
  right: 0; top: 0; bottom: 0;
  width: 5px;
  cursor: col-resize;
  background: transparent;
}
.um-col-resizer:hover { background: rgba(74, 144, 226, 0.35); }
.um-th-check { text-align: center !important; width: 60px; }
.um-th-write { text-align: center !important; width: 100px; }
.um-th-note  { }

.um-perm-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #f2f2f2;
  color: #333;
  vertical-align: middle;
}
.um-perm-table tr:hover td { background: #fafbff; }

.um-td-group {
  background: #f8f9fc;
  font-size: 12px;
  font-weight: 700;
  color: #444;
  vertical-align: middle;
  border-right: 1px solid #e8e8e8;
}
.um-td-check {
  text-align: center;
}
.um-td-check input[type="checkbox"] {
  width: 15px; height: 15px;
  cursor: pointer;
  accent-color: #4a90e2;
}
.um-td-note { font-size: 11px; color: #888; }
.um-td-empty { text-align: center; color: #aaa; padding: 16px !important; }

.um-group-start td { border-top: 2px solid #e8e8e8; }
.um-group-start td:first-child { border-top: 2px solid #e8e8e8; }
.um-row-admin { background: #fafafa; }
.um-row-admin td { color: #aaa; }

/* ── 오버레이 / 모달 공통 ── */
.um-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.um-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  width: 400px;
  max-width: 95vw;
  overflow: hidden;
}
.um-modal--sm { width: 340px; }

.um-modal-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #1a1a2e;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.um-modal-close {
  background: none; border: none; color: #fff;
  font-size: 17px; cursor: pointer; padding: 0; line-height: 1;
}
.um-modal-close:hover { color: #ccc; }

.um-modal-bd {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.um-modal-actions {
  display: flex; gap: 8px; justify-content: flex-end; margin-top: 4px;
}

.um-form-row {
  display: flex; flex-direction: column; gap: 3px;
}
.um-form-row label { font-size: 12px; font-weight: 600; color: #444; }
.um-form-row input {
  padding: 6px 8px; border: 1px solid #ccc; border-radius: 4px;
  font-size: 13px;
}
.um-form-row input:focus { outline: none; border-color: #4a90e2; }

.um-form-checks { display: flex; gap: 16px; font-size: 13px; }
.um-form-checks label { display: flex; align-items: center; gap: 5px; cursor: pointer; }
.um-form-error { color: #e74c3c; font-size: 12px; margin: 0; }

.um-reject-hint { font-size: 13px; color: #555; margin: 0; }
.um-reject-ta {
  width: 100%; box-sizing: border-box;
  padding: 8px; border: 1px solid #ccc; border-radius: 4px;
  font-size: 13px; resize: vertical; font-family: inherit;
}
.um-reject-ta:focus { outline: none; border-color: #4a90e2; }

/* ── 상세 팝업 ── */
.um-detail-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  width: 680px;
  max-width: 96vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.um-detail-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f8f8;
  flex-shrink: 0;
}
.um-detail-tab {
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
}
.um-detail-tab:hover { color: #333; background: #f0f2ff; }
.um-detail-tab.active { color: #1a1a2e; border-bottom-color: #4a90e2; font-weight: 700; background: #fff; }

.um-detail-body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.um-loading {
  padding: 32px;
  text-align: center;
  color: #aaa;
  font-size: 14px;
}

/* ── 기본정보 탭 ── */
.um-info-tab { padding: 0; }

.um-info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.um-info-table th {
  width: 110px;
  padding: 8px 14px;
  background: #f6f7fb;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
}
.um-info-table td {
  padding: 8px 14px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 13px;
  vertical-align: top;
}
.um-agree-icons { display: flex; gap: 12px; font-size: 12px; }

.um-memo-ta {
  width: 100%; box-sizing: border-box;
  padding: 7px; border: 1px solid #ccc; border-radius: 4px;
  font-size: 13px; resize: vertical; font-family: inherit;
}
.um-memo-ta:focus { outline: none; border-color: #4a90e2; }
.um-memo-btn { margin-top: 6px; }

/* ── 동의이력 탭 ── */
.um-agree-tab { padding: 12px; display: flex; flex-direction: column; gap: 12px; }

.um-agree-summary {
  display: flex; gap: 10px; flex-wrap: wrap;
}
.um-agree-sum-item {
  flex: 1 1; min-width: 140px;
  border: 1px solid #e8e8e8; border-radius: 6px;
  padding: 10px 12px;
  background: #fafafa;
  text-align: center;
}
.um-agree-sum-item.agreed { background: #f0f9f4; border-color: #b2dfca; }
.um-agree-sum-type { font-size: 12px; font-weight: 600; color: #555; }
.um-agree-sum-icon { font-size: 18px; margin: 4px 0; }
.um-agree-sum-ver  { font-size: 11px; color: #777; }
.um-agree-sum-dt   { font-size: 11px; color: #999; margin-top: 2px; }

/* ── 접근이력 탭 ── */
.um-login-tab { padding: 12px; display: flex; flex-direction: column; gap: 8px; }

/* ── 공통 이력 테이블 ── */
.um-hist-table {
  width: 100%; border-collapse: collapse; font-size: 12px;
}
.um-hist-table th {
  padding: 6px 10px;
  background: #f4f6fa; border-bottom: 2px solid #dde2ef;
  font-size: 12px; font-weight: 600; color: #555;
  text-align: left; white-space: nowrap;
}
.um-hist-table td {
  padding: 6px 10px; border-bottom: 1px solid #f0f0f0; color: #333;
}
.um-hist-table tr:hover td { background: #fafbff; }
.um-cell-agreed    { color: #1a9052; font-weight: 600; }
.um-cell-disagreed { color: #c0392b; font-weight: 600; }
.um-row-fail td    { color: #c0392b; background: #fff5f5; }
.um-td-device { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── 페이징 ── */
.um-paging {
  display: flex; align-items: center; justify-content: center; gap: 12px;
  padding: 8px 0; font-size: 13px; color: #555;
}
.um-paging button {
  padding: 3px 10px; border: 1px solid #ccc; border-radius: 3px;
  background: #fff; cursor: pointer; font-size: 13px;
}
.um-paging button:hover:not(:disabled) { background: #f0f0f0; }
.um-paging button:disabled { opacity: 0.4; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./src/pages/admin/UserManagePage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,QAAQ;AACV;;AAEA,YAAY,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE5D,aAAa;AACb;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA,mBAAmB,aAAa,EAAE,qBAAqB,EAAE;;AAEzD,eAAe;AACf;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA,uBAAuB,mBAAmB,EAAE,WAAW,EAAE;AACzD,wBAAwB,cAAc,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC7G;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA,oCAAoC,mBAAmB,EAAE,WAAW,EAAE;;AAEtE,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE;AACjG,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAEhE,qBAAqB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAChI,qBAAqB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9G,qBAAqB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE9G,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjI,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,WAAW,EAAE;;AAEzD,iBAAiB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AAChE,iBAAiB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AAChE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA,oBAAoB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACxF,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAE9D;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB,cAAc,eAAe,EAAE,QAAQ,EAAE;AACzC,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,SAAO,EAAE,YAAY,EAAE;AAC1G,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACpH,gBAAgB,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE;AAC1D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,gBAAgB,EAAE,WAAW;EAC9C,eAAe,EAAE,mBAAmB;AACtC;AACA,yBAAyB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAE5F,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA,eAAe,WAAW,EAAE;AAC5B,kBAAkB,kBAAkB,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE,gBAAgB,EAAE;AAC3E;EACE,kBAAkB;EAClB,QAAQ,EAAE,MAAM,EAAE,SAAS;EAC3B,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;AACA,wBAAwB,oCAAoC,EAAE;AAC9D,eAAe,6BAA6B,EAAE,WAAW,EAAE;AAC3D,eAAe,6BAA6B,EAAE,YAAY,EAAE;AAC5D,eAAe;;AAEf;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA,cAAc,eAAe,EAAE,WAAW,EAAE;AAC5C,eAAe,kBAAkB,EAAE,WAAW,EAAE,wBAAwB,EAAE;;AAE1E,qBAAqB,6BAA6B,EAAE;AACpD,iCAAiC,6BAA6B,EAAE;AAChE,gBAAgB,mBAAmB,EAAE;AACrC,mBAAmB,WAAW,EAAE;;AAEhC,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA,gBAAgB,YAAY,EAAE;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,WAAW;EAC3C,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE,cAAc;AAC9D;AACA,wBAAwB,WAAW,EAAE;;AAErC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa,EAAE,QAAQ,EAAE,yBAAyB,EAAE,eAAe;AACrE;;AAEA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACrE;EACE,gBAAgB,EAAE,sBAAsB,EAAE,kBAAkB;EAC5D,eAAe;AACjB;AACA,2BAA2B,aAAa,EAAE,qBAAqB,EAAE;;AAEjE,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7D,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACvF,iBAAiB,cAAc,EAAE,eAAe,EAAE,SAAS,EAAE;;AAE7D,kBAAkB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;AAC3D;EACE,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,sBAAsB,EAAE,kBAAkB;EACxD,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;AACzD;AACA,sBAAsB,aAAa,EAAE,qBAAqB,EAAE;;AAE5D,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;AACA,uBAAuB,WAAW,EAAE,mBAAmB,EAAE;AACzD,wBAAwB,cAAc,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE1G;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB,eAAe,UAAU,EAAE;;AAE3B;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;;AAE7D;EACE,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,sBAAsB,EAAE,kBAAkB;EACxD,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;AACzD;AACA,oBAAoB,aAAa,EAAE,qBAAqB,EAAE;AAC1D,eAAe,eAAe,EAAE;;AAEhC,iBAAiB;AACjB,gBAAgB,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEjF;EACE,aAAa,EAAE,SAAS,EAAE,eAAe;AAC3C;AACA;EACE,SAAO,EAAE,gBAAgB;EACzB,yBAAyB,EAAE,kBAAkB;EAC7C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACrE,qBAAqB,eAAe,EAAE,aAAa,EAAE;AACrD,qBAAqB,eAAe,EAAE,WAAW,EAAE;AACnD,qBAAqB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEpE,iBAAiB;AACjB,gBAAgB,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEhF,oBAAoB;AACpB;EACE,WAAW,EAAE,yBAAyB,EAAE,eAAe;AACzD;AACA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,gCAAgC;EACrD,eAAe,EAAE,gBAAgB,EAAE,WAAW;EAC9C,gBAAgB,EAAE,mBAAmB;AACvC;AACA;EACE,iBAAiB,EAAE,gCAAgC,EAAE,WAAW;AAClE;AACA,6BAA6B,mBAAmB,EAAE;AAClD,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAElG,cAAc;AACd;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS;EACtE,cAAc,EAAE,eAAe,EAAE,WAAW;AAC9C;AACA;EACE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB;EAC7D,gBAAgB,EAAE,eAAe,EAAE,eAAe;AACpD;AACA,yCAAyC,mBAAmB,EAAE;AAC9D,6BAA6B,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":["/* 사용자 관리 화면 */\n\n/* ── 전체 레이아웃 ── */\n.um-layout {\n  display: flex;\n  gap: 14px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ── 좌측 패널 ── */\n.um-left {\n  width: 300px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: #fff;\n  overflow: hidden;\n}\n\n/* ── 우측 패널 ── */\n.um-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: #fff;\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* ── 패널 헤더 ── */\n.um-panel-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #f0f2f8;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  border-bottom: 1px solid #dde2ef;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.um-count { font-size: 12px; color: #777; font-weight: 400; }\n\n/* ── 검색 ── */\n.um-search-wrap {\n  padding: 7px 10px;\n  border-bottom: 1px solid #eee;\n  flex-shrink: 0;\n}\n.um-search {\n  width: 100%;\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n.um-search:focus { outline: none; border-color: #4a90e2; }\n\n/* ── 필터 탭 ── */\n.um-filter-tabs {\n  display: flex;\n  border-bottom: 1px solid #e8e8e8;\n  flex-shrink: 0;\n}\n.um-filter-tab {\n  flex: 1;\n  padding: 5px 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #666;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  text-align: center;\n  white-space: nowrap;\n}\n.um-filter-tab:hover { background: #f5f6ff; color: #333; }\n.um-filter-tab.active { color: #1a1a2e; border-bottom-color: #4a90e2; font-weight: 700; background: #f0f4ff; }\n.um-tab-cnt {\n  display: inline-block;\n  background: #e8e8e8;\n  color: #555;\n  border-radius: 8px;\n  padding: 0 5px;\n  font-size: 10px;\n  margin-left: 2px;\n  font-weight: 600;\n}\n.um-filter-tab.active .um-tab-cnt { background: #4a90e2; color: #fff; }\n\n/* ── 사용자 카드 목록 ── */\n.um-user-list {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.um-user-card {\n  padding: 9px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n.um-user-card:hover    { background: #f6f8ff; }\n.um-user-card.selected { background: #eef2ff; border-left: 3px solid #4a90e2; padding-left: 9px; }\n.um-user-card:last-child { border-bottom: none; }\n\n.um-card-row1 {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n.um-card-name { font-size: 13px; font-weight: 700; color: #222; }\n\n.um-badge-admin    { font-size: 10px; background: #4a90e2; color: #fff; padding: 1px 5px; border-radius: 3px; font-weight: 500; }\n.um-badge-tmp      { font-size: 10px; background: #e07000; color: #fff; padding: 1px 5px; border-radius: 3px; }\n.um-badge-rejected { font-size: 10px; background: #c0392b; color: #fff; padding: 1px 5px; border-radius: 3px; }\n\n.um-status-badge   { font-size: 10px; font-weight: 600; padding: 1px 7px; border-radius: 8px; margin-left: auto; flex-shrink: 0; }\n.um-status--active   { background: #e6f9f0; color: #1a9052; }\n.um-status--pending  { background: #fff4e0; color: #b35e00; }\n.um-status--inactive { background: #f0f0f0; color: #999; }\n\n.um-card-id    { font-size: 11px; color: #888; margin-top: 3px; }\n.um-card-login { font-size: 11px; color: #999; margin-top: 2px; }\n.um-card-agree {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #555;\n}\n\n/* ── 액션 버튼 영역 ── */\n.um-actions {\n  border-top: 1px solid #dde2ef;\n  padding: 9px 12px;\n  flex-shrink: 0;\n  background: #fafbff;\n}\n.um-actions-title { font-size: 11px; color: #666; font-weight: 600; margin-bottom: 6px; }\n.um-actions-btns  { display: flex; flex-wrap: wrap; gap: 6px; }\n\n.btn-outline {\n  background: #fff;\n  color: #333;\n  border: 1px solid #bbb;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 3px 9px;\n}\n.btn-outline:hover:not(:disabled) { background: #f0f0f0; }\n.btn-outline:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── 우측 빈 상태 ── */\n.um-no-select {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #aaa;\n  font-size: 14px;\n}\n.um-empty {\n  padding: 16px;\n  text-align: center;\n  color: #aaa;\n  font-size: 13px;\n}\n\n/* ── 권한 헤더 ── */\n.um-perm-hd { flex-wrap: wrap; gap: 6px; }\n.um-perm-hd-left { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; flex: 1; min-width: 0; }\n.um-perm-title { font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.um-allchecks { display: flex; gap: 10px; flex-shrink: 0; }\n.um-allcheck-lbl {\n  display: flex; align-items: center; gap: 4px;\n  font-size: 12px; font-weight: 500; color: #444;\n  cursor: pointer; white-space: nowrap;\n}\n.um-allcheck-lbl input { width: 14px; height: 14px; cursor: pointer; accent-color: #4a90e2; }\n\n/* ── 관리자 안내 ── */\n.um-admin-notice {\n  padding: 14px 16px;\n  font-size: 13px;\n  color: #4a90e2;\n  background: #f0f6ff;\n  border-bottom: 1px solid #d0e4ff;\n}\n\n/* ── 권한 테이블 영역 ── */\n.um-perm-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.um-perm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  table-layout: fixed;\n}\n.um-perm-table th {\n  padding: 6px 10px;\n  background: #f4f6fa;\n  border-bottom: 2px solid #dde2ef;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.um-th-group { width: 80px; }\n.um-th-menuname { position: relative; user-select: none; overflow: hidden; }\n.um-col-resizer {\n  position: absolute;\n  right: 0; top: 0; bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  background: transparent;\n}\n.um-col-resizer:hover { background: rgba(74, 144, 226, 0.35); }\n.um-th-check { text-align: center !important; width: 60px; }\n.um-th-write { text-align: center !important; width: 100px; }\n.um-th-note  { }\n\n.um-perm-table td {\n  padding: 6px 10px;\n  border-bottom: 1px solid #f2f2f2;\n  color: #333;\n  vertical-align: middle;\n}\n.um-perm-table tr:hover td { background: #fafbff; }\n\n.um-td-group {\n  background: #f8f9fc;\n  font-size: 12px;\n  font-weight: 700;\n  color: #444;\n  vertical-align: middle;\n  border-right: 1px solid #e8e8e8;\n}\n.um-td-check {\n  text-align: center;\n}\n.um-td-check input[type=\"checkbox\"] {\n  width: 15px; height: 15px;\n  cursor: pointer;\n  accent-color: #4a90e2;\n}\n.um-td-note { font-size: 11px; color: #888; }\n.um-td-empty { text-align: center; color: #aaa; padding: 16px !important; }\n\n.um-group-start td { border-top: 2px solid #e8e8e8; }\n.um-group-start td:first-child { border-top: 2px solid #e8e8e8; }\n.um-row-admin { background: #fafafa; }\n.um-row-admin td { color: #aaa; }\n\n/* ── 오버레이 / 모달 공통 ── */\n.um-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.um-modal {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.18);\n  width: 400px;\n  max-width: 95vw;\n  overflow: hidden;\n}\n.um-modal--sm { width: 340px; }\n\n.um-modal-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 18px;\n  background: #1a1a2e;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n.um-modal-close {\n  background: none; border: none; color: #fff;\n  font-size: 17px; cursor: pointer; padding: 0; line-height: 1;\n}\n.um-modal-close:hover { color: #ccc; }\n\n.um-modal-bd {\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.um-modal-actions {\n  display: flex; gap: 8px; justify-content: flex-end; margin-top: 4px;\n}\n\n.um-form-row {\n  display: flex; flex-direction: column; gap: 3px;\n}\n.um-form-row label { font-size: 12px; font-weight: 600; color: #444; }\n.um-form-row input {\n  padding: 6px 8px; border: 1px solid #ccc; border-radius: 4px;\n  font-size: 13px;\n}\n.um-form-row input:focus { outline: none; border-color: #4a90e2; }\n\n.um-form-checks { display: flex; gap: 16px; font-size: 13px; }\n.um-form-checks label { display: flex; align-items: center; gap: 5px; cursor: pointer; }\n.um-form-error { color: #e74c3c; font-size: 12px; margin: 0; }\n\n.um-reject-hint { font-size: 13px; color: #555; margin: 0; }\n.um-reject-ta {\n  width: 100%; box-sizing: border-box;\n  padding: 8px; border: 1px solid #ccc; border-radius: 4px;\n  font-size: 13px; resize: vertical; font-family: inherit;\n}\n.um-reject-ta:focus { outline: none; border-color: #4a90e2; }\n\n/* ── 상세 팝업 ── */\n.um-detail-modal {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.18);\n  width: 680px;\n  max-width: 96vw;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.um-detail-tabs {\n  display: flex;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f8f8;\n  flex-shrink: 0;\n}\n.um-detail-tab {\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #666;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n}\n.um-detail-tab:hover { color: #333; background: #f0f2ff; }\n.um-detail-tab.active { color: #1a1a2e; border-bottom-color: #4a90e2; font-weight: 700; background: #fff; }\n\n.um-detail-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.um-loading {\n  padding: 32px;\n  text-align: center;\n  color: #aaa;\n  font-size: 14px;\n}\n\n/* ── 기본정보 탭 ── */\n.um-info-tab { padding: 0; }\n\n.um-info-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.um-info-table th {\n  width: 110px;\n  padding: 8px 14px;\n  background: #f6f7fb;\n  border-bottom: 1px solid #eee;\n  border-right: 1px solid #eee;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  text-align: left;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.um-info-table td {\n  padding: 8px 14px;\n  border-bottom: 1px solid #eee;\n  color: #333;\n  font-size: 13px;\n  vertical-align: top;\n}\n.um-agree-icons { display: flex; gap: 12px; font-size: 12px; }\n\n.um-memo-ta {\n  width: 100%; box-sizing: border-box;\n  padding: 7px; border: 1px solid #ccc; border-radius: 4px;\n  font-size: 13px; resize: vertical; font-family: inherit;\n}\n.um-memo-ta:focus { outline: none; border-color: #4a90e2; }\n.um-memo-btn { margin-top: 6px; }\n\n/* ── 동의이력 탭 ── */\n.um-agree-tab { padding: 12px; display: flex; flex-direction: column; gap: 12px; }\n\n.um-agree-summary {\n  display: flex; gap: 10px; flex-wrap: wrap;\n}\n.um-agree-sum-item {\n  flex: 1; min-width: 140px;\n  border: 1px solid #e8e8e8; border-radius: 6px;\n  padding: 10px 12px;\n  background: #fafafa;\n  text-align: center;\n}\n.um-agree-sum-item.agreed { background: #f0f9f4; border-color: #b2dfca; }\n.um-agree-sum-type { font-size: 12px; font-weight: 600; color: #555; }\n.um-agree-sum-icon { font-size: 18px; margin: 4px 0; }\n.um-agree-sum-ver  { font-size: 11px; color: #777; }\n.um-agree-sum-dt   { font-size: 11px; color: #999; margin-top: 2px; }\n\n/* ── 접근이력 탭 ── */\n.um-login-tab { padding: 12px; display: flex; flex-direction: column; gap: 8px; }\n\n/* ── 공통 이력 테이블 ── */\n.um-hist-table {\n  width: 100%; border-collapse: collapse; font-size: 12px;\n}\n.um-hist-table th {\n  padding: 6px 10px;\n  background: #f4f6fa; border-bottom: 2px solid #dde2ef;\n  font-size: 12px; font-weight: 600; color: #555;\n  text-align: left; white-space: nowrap;\n}\n.um-hist-table td {\n  padding: 6px 10px; border-bottom: 1px solid #f0f0f0; color: #333;\n}\n.um-hist-table tr:hover td { background: #fafbff; }\n.um-cell-agreed    { color: #1a9052; font-weight: 600; }\n.um-cell-disagreed { color: #c0392b; font-weight: 600; }\n.um-row-fail td    { color: #c0392b; background: #fff5f5; }\n.um-td-device { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* ── 페이징 ── */\n.um-paging {\n  display: flex; align-items: center; justify-content: center; gap: 12px;\n  padding: 8px 0; font-size: 13px; color: #555;\n}\n.um-paging button {\n  padding: 3px 10px; border: 1px solid #ccc; border-radius: 3px;\n  background: #fff; cursor: pointer; font-size: 13px;\n}\n.um-paging button:hover:not(:disabled) { background: #f0f0f0; }\n.um-paging button:disabled { opacity: 0.4; cursor: not-allowed; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
